<template lang="pug">
validation-observer(
  ref="obs"
  disabled
  v-slot="{ invalid, handleSubmit }"
)
  .d-flex.gap-3
    div
      .ev-label Протокол
      v-select(
        v-model="protocol"
        :items="$options.constants.PROTOCOLS"
        dense
        outlined
        hide-details
      )
    validation-provider(
      name="Ссылка"
      rules="required|url"
      v-slot="{ errors }"
    ).full-width
      ev-text-field(
        v-model="src"
        label="Ссылка"
        :error-messages="errors"
        toplabel
      )
  validation-provider(
    name="Описание"
    :rules="`required|max:${$options.constants.INPUT_LENGTH.textArea}`"
    v-slot="{ errors }"
  )
    ev-text-field(
      v-model="description"
      label="Описание"
      :counter="$options.constants.INPUT_LENGTH.textArea"
      :error-messages="errors"
      toplabel
    )
  v-btn.mt-5(
    color="success"
    :disabled="invalid"
    @click="handleSubmit(addLink)"
  ) Добавить
</template>

<script>
import { INPUT_LENGTH } from '@/constants/inputLength';
import { PROTOCOL_REGEXP, PROTOCOL } from '@/constants/protocol';

const PROTOCOLS = Object.values(PROTOCOL);

export default {
  constants: {
    INPUT_LENGTH,
    PROTOCOL_REGEXP,
    PROTOCOL,
    PROTOCOLS,
  },
  data() {
    return {
      protocol: this.$options.constants.PROTOCOL.https,
      src: '',
      fullSrc: '',
      description: '',
    };
  },
  watch: {
    src(value) {
      const isContainProtocol = this.$options.constants.PROTOCOL_REGEXP.test(value);
      if (isContainProtocol) {
        this.src = value.replace(this.$options.constants.PROTOCOL_REGEXP, '');
      }
      this.fullSrc = this.protocol + this.src;
    },
  },
  methods: {
    async addLink() {
      this.$emit('input', { src: this.fullSrc, description: this.description });
      this.src = null;
      this.description = null;
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
  },
};
</script>
